import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  form,
  Form as AppForm,
  TextArea
} from "MODULES/shared/components/Forms";

export function Form(props) {
  const { close } = props;

  return (
    <AppForm {...props} onSubmit={close}>
      <AppForm.Body>
        <Field name="body" component={TextArea} label="note" required />
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  close: PropTypes.func.isRequired
};

export default connect(undefined, undefined)(
  form({
    form: "viewNote"
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/ViewNote/Form.jsx